import { render, staticRenderFns } from "./training-class-wap.vue?vue&type=template&id=105e4fba&scoped=true"
import script from "./training-class-wap.vue?vue&type=script&lang=js"
export * from "./training-class-wap.vue?vue&type=script&lang=js"
import style0 from "./training-class-wap.vue?vue&type=style&index=0&id=105e4fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e4fba",
  null
  
)

export default component.exports